import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e227963"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-md screen-path" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "app-name" }, " GSALT > ", -1))
const _hoisted_3 = { class: "module-name" }
const _hoisted_4 = {
  key: 0,
  class: "final-path"
}


export default /*#__PURE__*/_defineComponent({
  props: {
    moduleName: null,
    finalPath: null
  },
  setup(__props: any) {

const props = __props as {
  moduleName: string
  finalPath?: string
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, _toDisplayString(__props.moduleName) + " " + _toDisplayString(__props.finalPath ? '> ' : ''), 1),
    (props.finalPath)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(props.finalPath), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})